import { render, staticRenderFns } from "./warningDetails.vue?vue&type=template&id=2d96edb0&scoped=true"
import script from "./warningDetails.vue?vue&type=script&lang=js"
export * from "./warningDetails.vue?vue&type=script&lang=js"
import style0 from "./warningDetails.vue?vue&type=style&index=0&id=2d96edb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d96edb0",
  null
  
)

export default component.exports